import React, { useState, useEffect } from 'react';
import { useRange } from 'react-instantsearch';

interface ProofingRangeInputProps {
  attributeMin: string;
  attributeMax: string;
}

export function ProofingRangeInput({ attributeMin, attributeMax }: ProofingRangeInputProps) {
  const { range: rangeMin, refine: refineMin } = useRange({ attribute: attributeMin });
  const { range: rangeMax, refine: refineMax } = useRange({ attribute: attributeMax });

  const defaultMin = 0;
  const defaultMax = 200;

  // Overall min/max from Algolia for both attributes
  const proofingMinMin = rangeMin.min ?? defaultMin; 
  const proofingMaxMax = rangeMax.max ?? defaultMax;

  const [minValue, setMinValue] = useState<string>('');
  const [maxValue, setMaxValue] = useState<string>('');

  const applyFilter = () => {
    const typedMin = minValue.trim() === '' ? undefined : Number(minValue);
    const typedMax = maxValue.trim() === '' ? undefined : Number(maxValue);

    const overallMin = proofingMinMin;
    const overallMax = proofingMaxMax;

    const filterMin = typedMin !== undefined && !isNaN(typedMin) ? typedMin : overallMin;
    const filterMax = typedMax !== undefined && !isNaN(typedMax) ? typedMax : overallMax;

    // key logic:
    // proofing_min <= filterMax (so refineMin: overallMin to filterMax)
    refineMin([overallMin, filterMax]);

    // proofing_max >= filterMin (so refineMax: filterMin to overallMax)
    refineMax([filterMin, overallMax]);

    setMinValue('');
    setMaxValue('');
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    applyFilter();
  };

  return (
    <form onSubmit={onSubmit} style={{ maxWidth: 220 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <input
          type="number"
          min={proofingMinMin}
          value={minValue}
          onChange={(e) => setMinValue(e.target.value)}
          placeholder={`${proofingMinMin}`}
          style={{
            width: '80px', // <--- Add this
            padding: '8px 10px',
            borderRadius: '10px',
            border: '1px solid #D1D1D1',
            marginRight: '12px',
          }}
        />
        <span style={{ fontSize: 14, fontWeight: '500', color: '#555', marginRight: '12px' }}>to</span>
        <input
          type="number"
          max={proofingMaxMax}
          value={maxValue}
          onChange={(e) => setMaxValue(e.target.value)}
          placeholder={`${proofingMaxMax}`}
          style={{
            width: '80px', // <--- Add this
            padding: '8px 10px',
            borderRadius: '10px',
            border: '1px solid #D1D1D1',
            marginRight: '12px',
          }}
        />
      </div>
      <button
        type="submit"
        style={{
          borderRadius: '10px',
          border: 'unset',
          display: 'inline-flex',
          padding: '10px 24px',
          marginTop: '10px',
          cursor: 'pointer',
        }}
      >
        Go
      </button>
    </form>
  );
}
